import { Layout } from "@/components/Layout";
import { NoindexSeo } from "@/components/Seo";
import { Link } from "react-router-dom";
import "./legal.css";

export default function CookiesPage() {
  return (
    <Layout>
      <NoindexSeo
        title="Gestion des cookies"
        path="/cookies"
      />
      <div className="legal">
        <div className="legal-wrap">
          <h1 className="legal-h1">Politique de gestion des cookies</h1>
          <p className="legal-updated">Mise à jour : 12 juillet 2026</p>

          <p className="legal-intro">
            Cette page décrit les cookies et traceurs utilisés par{" "}
            <b>Mon Diag Énergétique</b>, conformément à la directive ePrivacy et
            aux recommandations de la CNIL.
          </p>

          <h2 className="legal-h2">1. Qu'est-ce qu'un cookie ?</h2>
          <p className="legal-p">
            Un cookie est un petit fichier déposé sur votre terminal (ordinateur,
            tablette, smartphone) lors de la visite d'un site web. Il permet au
            site de mémoriser des informations sur votre visite (préférences,
            identifiant de session, statistiques d'usage).
          </p>

          <h2 className="legal-h2">2. Cookies utilisés</h2>

          <h3 className="legal-h3">2.1 Cookies strictement nécessaires</h3>
          <p className="legal-p">
            Ces cookies sont indispensables au fonctionnement du Service. Ils ne
            peuvent pas être désactivés. Aucun consentement n'est requis (art. 5
            §3 de la directive ePrivacy).
          </p>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Finalité</th>
                <th>Durée</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>session</b></td>
                <td>Maintien de la session d'authentification (HttpOnly, Secure, SameSite=Lax)</td>
                <td>Session (supprimé à la fermeture du navigateur)</td>
                <td>Strictement nécessaire</td>
              </tr>
            </tbody>
          </table>

          <h3 className="legal-h3">2.2 Cookies de mesure d'audience (à venir)</h3>
          <p className="legal-p">
            À l'activation d'un outil de mesure d'audience (Matomo), des cookies
            de statistiques anonymes pourront être déposés. Ces cookies ne seront
            activés qu'après votre consentement explicite, recueilli via la
            bannière de consentement. Vous pourrez les refuser ou les révoquer à
            tout moment depuis votre{" "}
            <Link to="/account" className="legal-link">page compte</Link>.
          </p>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Finalité</th>
                <th>Durée</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>_pk_id</b> (Matomo)</td>
                <td>Statistiques de visite anonymisées (visiteurs uniques)</td>
                <td>13 mois</td>
                <td>Mesure d'audience (opt-in)</td>
              </tr>
              <tr>
                <td><b>_pk_ses</b> (Matomo)</td>
                <td>Session de visite (durée de la visite)</td>
                <td>30 minutes</td>
                <td>Mesure d'audience (opt-in)</td>
              </tr>
            </tbody>
          </table>
          <div className="legal-callout">
            <b>Statut actuel :</b> aucun cookie de mesure d'audience n'est
            actuellement actif. L'outil de mesure d'audience sera activé
            uniquement après mise en place de la bannière de consentement et de
            votre accord explicite.
          </div>

          <h3 className="legal-h3">2.3 Cookies publicitaires (à venir)</h3>
          <p className="legal-p">
            À l'activation de publicités contextuelles, des cookies pourront être
            déposés. Ces cookies ne seront activés qu'après votre consentement
            explicite. Vous pourrez les révoquer à tout moment depuis votre{" "}
            <Link to="/account" className="legal-link">page compte</Link>.
          </p>

          <h2 className="legal-h2">3. Consentement</h2>
          <p className="legal-p">
            Conformément aux recommandations de la CNIL (mise à jour 2024) :
          </p>
          <ul className="legal-ul">
            <li>Les cookies non strictement nécessaires ne sont déposés qu'après votre consentement explicite.</li>
            <li>Le bouton « Tout refuser » est aussi visible et accessible que le bouton « Tout accepter ».</li>
            <li>Vous pouvez retirer votre consentement à tout moment depuis votre <Link to="/account" className="legal-link">page compte</Link> (section « Préférences de consentement »).</li>
            <li>Le retrait du consentement ne affecte pas la licéité du traitement effectué avant le retrait.</li>
          </ul>

          <h2 className="legal-h2">4. Gestion de vos préférences</h2>
          <p className="legal-p">
            Vous pouvez gérer vos préférences de consentement de deux façons :
          </p>
          <ul className="legal-ul">
            <li><b>Depuis votre navigateur</b> : vous pouvez configurer votre navigateur pour accepter, refuser ou supprimer les cookies. Le paramétrage est propre à chaque navigateur.</li>
            <li><b>Depuis votre <Link to="/account" className="legal-link">page compte</Link></b> : la section « Préférences de consentement » vous permet d'activer ou de désactiver les consentements marketing, statistiques et publicitaires à tout moment.</li>
          </ul>

          <h2 className="legal-h2">5. Transfert hors UE</h2>
          <p className="legal-p">
            Les cookies déposés sont stockés sur votre terminal et les données
            collectées sont traitées en France (hébergement Scaleway Paris). Aucun
            transfert de données vers un pays tiers n'est effectué.
          </p>

          <h2 className="legal-h2">6. Contact</h2>
          <p className="legal-p">
            Pour toute question relative à l'utilisation des cookies, contactez-nous
            aux coordonnées indiquées dans les{" "}
            <Link to="/mentions-legales" className="legal-link">mentions légales</Link>.
          </p>
        </div>
      </div>
    </Layout>
  );
}
